var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative min-h-80" },
    [
      _c("loading", {
        staticClass: "mt-40 md:mt-48 h-32",
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": false
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "md:mt-16 mt-8 px-4 md:px-2" },
            [
              _c("form", { ref: "form", staticClass: "w-full md:px-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "\n                    container\n                    hidden\n                    md:flex\n                    flex-wrap\n                    py-2\n                    px-2\n                    justify-between\n                "
                  },
                  _vm._l(_vm.data.designation, function(designation) {
                    return _c(
                      "div",
                      {
                        key: designation.value,
                        staticClass: "w-full md:w-auto p-1 text-base",
                        class:
                          _vm.filterDesignation === designation.value
                            ? "font-serif"
                            : "font-serif-300"
                      },
                      [
                        _c("input-radio", {
                          attrs: {
                            name: "designation",
                            value: designation.value,
                            id: designation.value,
                            description: designation.label
                          },
                          model: {
                            value: _vm.filterDesignation,
                            callback: function($$v) {
                              _vm.filterDesignation = $$v
                            },
                            expression: "filterDesignation"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex md:hidden flex-wrap -mx-4 md:-mx-2" },
                  [
                    _c(
                      "div",
                      { ref: "select", staticClass: "w-full js-team" },
                      [
                        _c("v-select", {
                          attrs: {
                            clearable: false,
                            options: _vm.data.designation,
                            reduce: function(filterDesignation) {
                              return filterDesignation.value
                            },
                            label: "label"
                          },
                          model: {
                            value: _vm.filterDesignation,
                            callback: function($$v) {
                              _vm.filterDesignation = $$v
                            },
                            expression: "filterDesignation"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.data.area, function(area) {
                return _c(
                  "section",
                  { key: area.value, staticClass: "js-section" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "\n                    gridWrap\n                    container\n                    py-4\n                    px-4\n                    mt-4\n                    md:mt-16\n                    mb-0\n                    md:mb-4\n                "
                      },
                      [
                        _c("h2", { staticClass: "text-center" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "\n                            border-t-6 border-b-6 border-transparent\n                            hover:border-brand\n                            js-step\n                        "
                            },
                            [_vm._v(_vm._s(area.label))]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "\n                    mx-auto\n                    md:flex\n                    md:content-center\n                    md:flex-wrap\n                    md:justify-center\n                    py-2\n                    px-2\n                    container\n                "
                      },
                      [
                        _vm._l(
                          _vm.filterByValue(_vm.filteredEntries, area.value),
                          function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "gridElement py-2 px-2 w-full md:w-1/2 lg:w-1/3"
                              },
                              [
                                _c(
                                  "article",
                                  {
                                    staticClass:
                                      "\n                            flex-1\n                            h-96\n                            md:h-128\n                            w-full\n                            group\n                            relative\n                            overflow-hidden\n                        "
                                  },
                                  [
                                    item.images
                                      ? _c("image-src-set", {
                                          attrs: {
                                            "webp-src-set": item.images.webP,
                                            "jpg-src-set": item.images.jpg,
                                            classes:
                                              "w-full h-96 md:h-128 lazyload",
                                            alt: item.imageTitle
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "\n                                articleWrap\n                                absolute\n                                top-0\n                                bottom-0\n                                mt-68\n                                md:mt-0\n                                group-hover:transform-up\n                                bg-brand-50\n                                md:bg-transparent\n                                md:group-hover:bg-brand-50\n                                transform-down-5\n                                w-full\n                                h-96\n                                md:h-128\n                            "
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "articleContainer" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "\n                                        articleInner\n                                        absolute\n                                        top-0\n                                        flex flex-col\n                                        text-left\n                                        overflow-hidden\n                                        h-full\n                                        w-full\n                                        py-3\n                                        px-4\n                                        md:justify-center\n                                        ease-in-out\n                                        duration-200\n                                    "
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "articleBody"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "\n                                                mb-0\n                                                font-serif\n                                                text-xl text-white\n                                                md:mt-12\n                                            "
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(item.title) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "\n                                                text-lg text-white\n                                                mt-auto\n                                                md:mt-4\n                                                font-sans\n                                            "
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(item.type) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "\n                                                hidden\n                                                md:block\n                                                text-lg text-white\n                                                mt-2\n                                                font-sans\n                                            ",
                                                        attrs: {
                                                          href:
                                                            "mailto:" +
                                                            item.email
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.email)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "\n                                                hidden\n                                                md:block\n                                                text-lg text-white\n                                                font-sans\n                                            ",
                                                        attrs: {
                                                          href:
                                                            "tel:" + item.phone
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.phone)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "\n                                        absolute\n                                        px-4\n                                        py-3\n                                        mt-16\n                                        md:bottom-0\n                                        text-white\n                                        font-sans\n                                        text-lg\n                                    ",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openModal(item)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v(">")]
                                                ),
                                                _vm._v(
                                                  "mehr\n                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _vm.modalVisible
                          ? _c("modal", {
                              attrs: { data: _vm.modalData },
                              on: {
                                close: function($event) {
                                  _vm.modalVisible = false
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._m(0, true)
                  ]
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "\n                    gridWrap\n                    container\n                    py-4\n                    px-4\n                    mt-4\n                    md:mt-16\n                    flex\n                    justify-center\n                "
      },
      [
        _c("hr", {
          staticClass: "bg-grey-darkest h-px opacity-25 w-3/5 mb-0 mt-0"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }